{
	"backToManageDeclarations": "Назад към Управление на декларации",
	"kpi": {
		"quantity": "Количество",
		"carbonSavings": "Въглеродни редукции"
	},
	"downloadAllDeclarations": "Изтегли всички декларации",
	"errors": {
		"notFound": "Проектът не е намерен"
	}
}
